import React from 'react';
import { MapPin, Phone, Mail, Instagram, ArrowUpRight } from 'lucide-react';
import { studio } from '../mock';
import Logo from './Logo';

const exploreLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Our Work', href: '#work' },
  { label: 'Warranty', href: '#trust' },
  { label: 'FAQs', href: '#faq' },
  { label: 'Contact', href: '#contact' },
];

export default function Footer() {
  return (
    <footer className="pt-12 pb-28 md:pb-10 bg-[#16150f] text-white">
      <div className="section-pad max-w-[1440px] mx-auto">
        <div className="grid md:grid-cols-[1.4fr_0.7fr] gap-10 md:gap-16 pb-10">
          <div>
            <Logo variant="white" className="h-7 sm:h-9" />
            <p className="mt-4 text-sm text-white/55 leading-relaxed max-w-md">
              Premium car &amp; bike PPF, wrapping and ceramic coating in Bengaluru.
            </p>
            <div className="mt-5 space-y-2.5 text-sm text-white/60">
              <p className="flex items-start gap-3"><MapPin className="w-4 h-4 text-[#ff5a1f] mt-0.5 shrink-0" /> {studio.address}</p>
              <a href={studio.phoneHref} className="flex items-center gap-3 hover:text-white transition-colors"><Phone className="w-4 h-4 text-[#ff5a1f]" /> {studio.phone}</a>
              <a href={`mailto:${studio.email}`} className="flex items-center gap-3 hover:text-white transition-colors"><Mail className="w-4 h-4 text-[#ff5a1f]" /> {studio.email}</a>
            </div>
            <div className="mt-5">
              <a href={studio.instagram} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-white/15 inline-flex items-center justify-center text-white/70 hover:bg-[#ff5a1f] hover:border-[#ff5a1f] hover:text-white transition-all"><Instagram className="w-4 h-4" /></a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-bold tracking-widest text-white uppercase mb-4">Explore</h4>
            <ul className="space-y-2.5">
              {exploreLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="group inline-flex items-center gap-1 text-sm text-white/55 hover:text-[#ff5a1f] transition-colors">
                    {l.label} <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-white/10">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} VINYLED LLP. Bengaluru, India.</p>
        </div>
      </div>
    </footer>
  );
}
